// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headerIcon":"post-list__headerIcon__1Mwqu"};